export default "__VITE_ASSET__BQDpE5tB__"